const Art2Section = () => {
  return (
    <section className=" flex flex-col sm:flex-row items-center sm:pt-4 pb-24 mt-20 sm:mt-36 md:mt-40 px-6">
      <div className="sm:w-1/2">
      <img
  src="./assets/logo2.png"
  alt="image 3"
  className="sm:object-cover bg-black bg-opacity-50 rounded-lg max-w-lg -mt-16 sm:-mt-56 md:-mt-36 w-full h-auto mx-auto shadow-lg shadow-gray-500 transform transition-transform duration-700 ease-out hover:translate-x-0 -translate-x-10"
/>
      </div>
      <div className="sm:w-1/2 bg-marfim bg-opacity-50 rounded-lg pt-4 sm:p-8 sm:pl-16">
        <h2 className="text-4xl font-bold text-black mb-4">
          DaBolivia Peças Automotivas 
        </h2>
        <p className="text-gray mb-6">
          Lorem ipsum dolor sit amet consectetur adipisicing elit. Dolore, aut consequuntur! Culpa provident fugit ea est vero at consequatur. Reprehenderit velit magni unde voluptates dolorum exercitationem consequuntur pariatur, maiores quo.
        </p>
       
      </div>
    </section>
  );
};

export default Art2Section;
